

export default {
  data() {
    return {
      styleDialogShow: false,
      scriptDialogShow: false
    }
  },
  mounted() {
    
  },
  methods: {
    async savePageData() {
      const code = await this.$store.dispatch('page/savePageData', { id: this.$route.meta.channelId });
      if(code === 20001) {
        this.$message({
          message: '页面数据保存成功！',
          type: 'success'
        });
      } else {
        this.$message({
          message: '页面数据保存失败，请稍后重试！',
          type: 'error'
        });
      }
    },
    showAddSection() {
      const sections = this.$store.state.page.pageData.sections;
      if(sections) {
        this.$store.commit('editor/showAddSection', { index: sections.length });
      }
    },
    // updateSection(e, i, j, k) {
    //   const section = { ...this.section };
    //   if (k) {
    //     section[i][j][k] = e.target.value;
    //   } else {
    //     section[i] = e.target.value;
    //   }
    //   this.$store.commit('page/setSection', { section });
    // },
  }
}
